var pin_r = 8;
var head = 8;
var point_load_arrow_head = 8;
var dist_load_arrow_shaft = 35;
var point_load_arrow_shaft = 60;
var moment_radius = 20;
var dimension_tick = 10;

//highlight element when mouse is over element
function setSelectable( element, unselect_attr, select_attr, dom_class_id ) {
    element.node.onmouseover =
        function() {
            element.attr(select_attr);
            this.style.cursor = 'pointer';
            if( dom_class_id )
                $("."+dom_class_id).addClass('ws-ui-table-row-select');
        };
    element.node.onmouseout =
        function() {
            element.attr(unselect_attr);
            if( dom_class_id )
                $("."+dom_class_id).removeClass('ws-ui-table-row-select');
        };
}

//hightlight the destination object when the mouse is over hover_elem
function setSelectableTrigger( hover_elem, dest_elem, unselect_attr, select_attr, dom_class_id ) {
    hover_elem.node.onmouseover =
        function() {
            dest_elem.attr(select_attr);
            this.style.cursor = 'pointer';
            //alert( dom_class_id );
            if( dom_class_id )
                $("."+dom_class_id).addClass('ws-ui-table-row-select');
        };
    hover_elem.node.onmouseout =
        function() {
            dest_elem.attr(unselect_attr);
            if( dom_class_id )
                $("."+dom_class_id).removeClass('ws-ui-table-row-select');
        };
}

function drawBeamSpanForShearMomentLabel(x1, x2, y1, y2, span_label, dimension_text, myCanvas, dom_class_id) {
    var y = y1;
    var t = y2-y1;
    var L = x2 - x1;
    var index = Number(dom_class_id.split("_")[1]);
    var span_attr = steel_span_attr;

    var b = myCanvas.rect(x1, y, L, t );
    b.attr( span_attr );
    //when we hover over one beam highlight them all...
    setSelectable(b, span_attr, selected_attr, dom_class_id);
    b.node.onclick = function(){ openModalSpanDialog(index); };
    var path_offset = 4;
    var pathStr = pathM(x1, y1+path_offset) + pathL(x2, y1+path_offset) + pathM(x2, y2-path_offset) + pathL(x1, y2-path_offset);
    var p = myCanvas.path(pathStr);
    setSelectableTrigger(p, b, span_attr, selected_attr, dom_class_id);
    //draw dimension
    drawSpanDimension(x1, x2, y1, y2, dimension_text, b, myCanvas, dom_class_id);
    return [b, p];
}

function drawBeamSpan(x1, x2, y1, y2, span_attr, span_label, dimension_text, shape, myCanvas, dom_class_id) {
    var y = y1;
    var t = y2-y1;
    var L = x2 - x1;
    var index = Number(dom_class_id.split("_")[1]);

    var b = myCanvas.rect(x1, y, L, t );
    b.attr( span_attr );
    //when we hover over one beam highlight them all...
    setSelectable(b, span_attr, selected_attr, dom_class_id);
    b.node.onclick = function(){ openModalShapeDialog(); };
    var top_path_offset = 0;
    var bottom_path_offset = 0;
    if(hasFlanges(shape)) {
        top_path_offset = 4;
        bottom_path_offset = 4;
    }
    if(hasTopFlange(shape)) {
        top_path_offset = 4;
        bottom_path_offset = 0;
    }
    if(hasBottomFlange(shape)) {
        top_path_offset = 0;
        bottom_path_offset = 4;
    }

    var pathStr = pathM(x1, y1+top_path_offset) + pathL(x2, y1+top_path_offset) + pathM(x2, y2-bottom_path_offset) + pathL(x1, y2-bottom_path_offset);
    var p = myCanvas.path(pathStr);
    setSelectableTrigger(p, b, span_attr, selected_attr, dom_class_id);
    var c = myCanvas.circle(x1+L/2,y+t/2,t/3);
    c.attr("fill","#ffffff");
    setSelectableTrigger(c, b, span_attr, selected_attr, dom_class_id);
    c.node.onclick = function(){ openModalSpanDialog(index); };
    var l = myCanvas.text(x1+L/2,y+t/2,span_label);
    l.attr("font-size","12");
    setSelectableTrigger( l, b, span_attr, selected_attr , dom_class_id );
    l.node.onclick = function(){ openModalSpanDialog(index); };
    //draw dimension
    drawSpanDimension(x1, x2, y1, y2, dimension_text, b, myCanvas, dom_class_id);
    return [b, p];
}

function drawBeamSpanResultsView(xs, ys, myCanvas) {
    var pathStr = pathM(xs[0], ys[0]);
    for(var i in xs) {
        if(i == 0) { continue; }
        pathStr += pathL(xs[i], ys[i]);
    }
    var p = myCanvas.path(pathStr);
    p.attr("stroke-width", medium_stroke);
    return p;
}


function drawSpanDimension(x1, x2, y1, y2, label, element, myCanvas, dom_class_id) {
    var x = x1;
    var y = y1;
    var t = y2-y1;
    var L = x2 - x1;
    var index = Number(dom_class_id.split("_")[1]);
    drawLine(x, y+3.0*t, x+L, y+3.0*t, myCanvas);
    drawLine(x, y+2.5*t, x, y+3.5*t, myCanvas);
    drawLine(x+L, y+2.5*t, x+L, y+3.5*t, myCanvas);
    var l = myCanvas.text(x+L/2,y+3.5*t,label);
    l.attr("font-size","14");
    l.node.onclick = function(){ openModalSpanDialog(index); };
    l.node.onmouseover = function() {
        element.attr(selected_attr);
        this.style.cursor = 'pointer';
        $("."+dom_class_id).addClass('ws-ui-table-row-select');
        l.attr("fill","#0d86d7");
    };
    l.node.onmouseout = function() {
        element.attr(span_attr);
        $("."+dom_class_id).removeClass('ws-ui-table-row-select');
        l.attr("fill","#000000");
    };
}

function drawExtremeDimension(x1, x2, y, label, myCanvas) {
    var x = x1;
    var L = x2 - x1;
    drawLine(x, y, x+L, y, myCanvas);
    drawLine(x, y-10, x, y+10, myCanvas);
    drawLine(x+L, y-10, x+L, y+10, myCanvas);
    var l = myCanvas.text(x+L/2,y+16,label);
    l.attr("font-size","12");
}


var addRemoveWidth = 10;
function drawAddRemoveSpan( x, y, t, myCanvas, dom_class_id ){
    /*var x2 = x + addRemoveWidth;
    var pathStr = pathM(x, y) + pathL(x2, y) + pathM(x2, y-t) + pathL(x1, y2-path_offset);
    var p = myCanvas.path(pathStr);
    setSelectableTrigger(p, b, span_attr, selected_attr, dom_class_id);
    var c = myCanvas.circle(x1+L/2,y+t/2,t/3);
    c.attr("fill","#ffffff");
    setSelectableTrigger(c, b, span_attr, selected_attr, dom_class_id);
    c.node.onclick = function(){ spanWidget.Open(dom_class_id);}
    var l = myCanvas.text(x1+L/2,y+t/2,span_label);
    l.attr("font-size","12");
    setSelectableTrigger( l, b, span_attr, selected_attr , dom_class_id );
    l.node.onclick = function(){ spanWidget.Open(dom_class_id);}*/

}

function drawSupport(type, x, y, t, myCanvas, dom_class_id) {
    if( type.match(/pinned/) ) return drawSimpleSupport(x, y, myCanvas, dom_class_id);
    else if( type.match(/roller/) ) return drawRollerSupport(x, y, myCanvas, dom_class_id);
    else if(type.match(/fixed/) ) return drawFixedSupport(x, y, t, myCanvas, dom_class_id);
    else return drawFreeSupport(x, y, t, myCanvas, dom_class_id);
}

function drawSimpleSupport(x, y, myCanvas, dom_class_id) {
    var tri = drawTriangle(pin_r*2, x, y, myCanvas );
    tri.attr(support_attr);
    setSelectable( tri, support_attr, selected_attr, dom_class_id);
    tri.node.onclick = function(){ CycleSupport(dom_class_id); };
    //label
    var l = myCanvas.text(x, y + 26, "Pinned");
    l.attr("font-size","12");
    setSelectableTrigger(l, tri, support_attr, {stroke : selected_color}, dom_class_id);
    l.node.onclick = function(){ CycleSupport(dom_class_id); };
    l.toFront();
    l.node.onmouseover = function() {
        tri.attr(selected_attr);
        this.style.cursor = 'pointer';
        //$("."+dom_class_id).addClass('ws-ui-table-row-select');
        l.attr("fill","#0d86d7");
    };
    l.node.onmouseout = function() {
        tri.attr(support_attr);
        //$("."+dom_class_id).removeClass('ws-ui-table-row-select');
        l.attr("fill","#000000");
    };
    return tri;
}

function drawRollerSupport(x, y, myCanvas, dom_class_id) {
    var c = myCanvas.circle(x, y+pin_r, pin_r );
    c.attr( support_attr );
    setSelectable( c, support_attr, selected_attr, dom_class_id );
    c.node.onclick = function(){ CycleSupport(dom_class_id); };
    return c;
}

function drawFreeSupport(x, y, t, myCanvas, dom_class_id) {
    var r = myCanvas.rect(x-0.25*pin_r, y-t, 0.5*pin_r, t );
    r.attr( free_support_attr );
    setSelectable( r, free_support_attr, selected_attr, dom_class_id );
    r.node.onclick = function(){ CycleSupport(dom_class_id); };
    //label
    var l = myCanvas.text(x, y + 26, "Free");
    l.attr("font-size","12");
    setSelectableTrigger(l, r, support_attr, {stroke : selected_color}, dom_class_id);
    l.node.onclick = function(){ CycleSupport(dom_class_id); };
    l.toFront();
    l.node.onmouseover = function() {
        r.attr(selected_attr);
        this.style.cursor = 'pointer';
        //$("."+dom_class_id).addClass('ws-ui-table-row-select');
        l.attr("fill","#0d86d7");
    };
    l.node.onmouseout = function() {
        r.attr(free_support_attr);
        //$("."+dom_class_id).removeClass('ws-ui-table-row-select');
        l.attr("fill","#000000");
    };
    return r;
}

function drawFixedSupport(x, y, t, myCanvas, dom_class_id) {
    var r = myCanvas.rect(x-pin_r, y-pin_r-t, 2*pin_r, 2*pin_r+t );
    r.attr( support_attr );
    setSelectable( r, support_attr, selected_attr, dom_class_id );
    r.node.onclick = function(){ CycleSupport(dom_class_id); };
    //label
    var l = myCanvas.text(x, y + 26, "Fixed");
    l.attr("font-size","12");
    setSelectableTrigger(l, r, support_attr, {stroke : selected_color}, dom_class_id);
    l.node.onclick = function(){ CycleSupport(dom_class_id); };
    l.toFront();
    l.node.onmouseover = function() {
        r.attr(selected_attr);
        this.style.cursor = 'pointer';
        //$("."+dom_class_id).addClass('ws-ui-table-row-select');
        l.attr("fill","#0d86d7");
    };
    l.node.onmouseout = function() {
        r.attr(support_attr);
        //$("."+dom_class_id).removeClass('ws-ui-table-row-select');
        l.attr("fill","#000000");
    };
    return r;
}

function drawPointLoad(direction, x, y, label, dimLabel, myCanvas, dom_class_id) {
    var a = null, index = Number(dom_class_id.split("_")[1]);
    if( direction == "up" ) a = drawUpArrow(x, y, point_load_arrow_shaft, myCanvas);
    else a = drawDownArrow(x, y, point_load_arrow_shaft, myCanvas);
    a.attr( point_load_attr );
    setSelectable(a, point_load_attr, {stroke : selected_color}, dom_class_id);
    a.node.onclick = function(){ openPointLoadDialog(index); };
    //our label
    var tokens = label.split(/\n/);
    var lines = tokens.length;
    var l = myCanvas.text(x, y - point_load_arrow_shaft - 12*lines,label);
    l.attr("font-size","12");
    setSelectableTrigger(l, a, point_load_attr, {stroke : selected_color}, dom_class_id);
    l.node.onclick = function(){ openPointLoadDialog(index); };
    l.toFront();

    //var totalLength = beam.TotalLength();
    //var x_scale = canvasRect[0]/(1.1*totalLength);
    //x_start = 0.05*totalLength*x_scale;
    //drawPointLoadDimension(x_start, x, y - point_load_arrow_shaft + dimension_tick, dimLabel, a, myCanvas, dom_class_id);
    return l;
}

function drawForceReaction(direction, x, y, label, dimLabel, myCanvas) {
    var a = null, l = null;
    if(direction == "up"){
        a = drawUpArrow(x, y + point_load_arrow_shaft + point_load_arrow_head, point_load_arrow_shaft, myCanvas);
        l = myCanvas.text(x, y + point_load_arrow_shaft + head + 12,label);
    } else {
        a = drawDownArrow(x, y - point_load_arrow_head, point_load_arrow_shaft, myCanvas);
        l = myCanvas.text(x, y - point_load_arrow_shaft - head - 12,label);
    }
    a.attr( point_load_attr );
    l.attr("font-size","12");
    l.toFront();
    return [a, l];
}

function drawMomentLoad(x, y, t, label, myCanvas, dom_class_id) {
    var a = drawMomentArrow(x, y+t/2, moment_radius, myCanvas), index = Number(dom_class_id.split("_")[1]);
    a.attr( point_load_attr );
    setSelectable(a, point_load_attr, {stroke : selected_color}, dom_class_id);
    a.node.onclick = function(){ openMomentDialog(index); };
    //our label
    var tokens = label.split(/\n/);
    var lines = tokens.length;
    var l = myCanvas.text(x + 36, y + t + 24*lines - 8,label);
    l.attr("font-size","12");
    setSelectableTrigger(l, a, point_load_attr, {stroke : selected_color}, dom_class_id);
    l.node.onclick = function(){ openMomentDialog(index); };
    l.toFront();
    return l;
}

function drawMomentReaction(x, y, t, label, myCanvas, dom_class_id) {
    var a = drawMomentArrow(x, y+t/2, moment_radius, myCanvas), index = Number(dom_class_id.split("_")[1]);
    a.attr( point_load_attr );
    var l = myCanvas.text(x + 36, y + t + 24,label);
    l.attr("font-size","12");
    l.toFront();
    return l;
}

function drawPointLoadDimension( xstart, xend, y, label, parentElem, myCanvas, dom_class_id) {
    var L = xend, index = Number(dom_class_id.split("_")[1]);
    drawLine(xstart, y, xend, y, myCanvas);
    drawLine(xstart, y-dimension_tick, xstart, y+dimension_tick, myCanvas);
    drawLine(xend, y-dimension_tick, xend, y+dimension_tick, myCanvas);

    var l = myCanvas.text(L/2,y-14,label);
    l.attr("font-size","14");
    l.node.onclick = function(){ openPointLoadDialog(index); };
    l.node.onmouseover = function() {
        parentElem.attr({stroke : selected_color});
        this.style.cursor = 'pointer';
        //$("."+dom_class_id).addClass('ws-ui-table-row-select');
        l.attr("fill","#0d86d7");
    };
    l.node.onmouseout = function() {
        parentElem.attr(point_load_attr);
        //$("."+dom_class_id).removeClass('ws-ui-table-row-select');
        l.attr("fill","#000000");
    };
}


function drawLinearLoad( q1, q2, x1, x2, y1, y2, label, myCanvas, dom_class_id) {
    var y = y1;
    var length = dist_load_arrow_shaft;
    var dist = x2-x1;
    var labelX = x1 + dist / 2;
    var bbox = renderedTextSize(label, "12");
    bbox.width += 20;
    bbox.height *= 1.25;
    // draw at least 3 arrows but no more than 20
    // draw arrows every 12 inches
    var nArrows = Math.round(Math.max(Math.min(dist / 12.0, 12), 3));
    var delta = dist/(nArrows-1);
    var h1 = length;
    var h2 = length;
    var loadIndex = dom_class_id.split(/wsDistLoad_/)[1];
    if( Math.abs(q2) > Math.abs(q1) ){
        //h1 = (q1 === 0.0) ? 0.0 : length * 0.5;
        h2 = length;
        h1 = q1 / q2 * length;
        //labelX = x1 + dist * 0.85;
    } else {
        h1 = length;
        h2 = q2 / q1 * length;
        //labelX = x1 + dist * 0.15;
    }
    var r = drawTrapazoid( x1, y1, x2, y2, h1, h2, myCanvas );
    //var r = myCanvas.rect( x1, y-length, dist, length);
    r.attr( dist_load_rect_attr );
    setSelectable( r, dist_load_rect_attr, selected_attr, dom_class_id );
    r.node.onclick = function(){ openLinearLoadDialog(loadIndex); };
    var i = (q1 === 0.0 || q2 === 0.0) ? 1 : 0;
    for(i = 0; i < nArrows; i++) {
        var arrow_length = h1 - (h1 - h2) * i / (nArrows - 1);
        //if(arrow_length < head * 1.2) {
        //    continue;
        //}
        var a = drawDownArrow(x1 + i*delta, y, arrow_length, myCanvas);
        a.attr( dist_load_arrow_attr );
        setSelectableTrigger(a, r, dist_load_rect_attr, selected_attr, dom_class_id );
        a.node.onclick = function(){ openLinearLoadDialog(loadIndex); };
    }
    //our label
    var tokens = label.split(/\n/);
    var lines = tokens.length;

    var labelBoxY = y - length + 4;

    var r2 = myCanvas.rect(labelX - (bbox.width * 0.5), labelBoxY, bbox.width, bbox.height);
    r2.attr(label_rect_attr);

    var l = myCanvas.text(labelX, labelBoxY + 8, label);
    l.attr("font-size","12");

    //var l = myCanvas.text(x1 + dist/2,y-length-13*lines,label);
    //l.attr("font-size","12");
    setSelectableTrigger(l, r, dist_load_rect_attr, selected_attr, dom_class_id);
    l.node.onclick = function(){ openLinearLoadDialog(loadIndex); };
    l.toFront();
    return l;
}


function drawDistributedLoad(direction, x1, x2, y1, label, myCanvas, dom_class_id) {
    var y = y1;
    var length = dist_load_arrow_shaft;
    var dist = x2-x1;
    var nArrows = Math.round(Math.max(Math.min(dist / 12.0, 12), 3));
    var delta = dist/(nArrows-1);
    var r = myCanvas.rect( x1, y-length, dist, length);
    var loadIndex = dom_class_id.split(/wsDistLoad_/)[1];
    r.attr(dist_load_rect_attr);
    //r.attr(label_rect_attr);
    setSelectable(r, dist_load_rect_attr, selected_attr, dom_class_id);
    r.node.onclick = function(){ openUniformLoadDialog(loadIndex); };
    for( var i = 0; i < nArrows; i++ ) {
        var a = null;
        if(direction === "up") a = drawUpArrow(x1 + i*delta, y, length, myCanvas);
        else a = drawDownArrow(x1 + i*delta, y, length, myCanvas);
        a.attr( dist_load_arrow_attr );
        setSelectableTrigger(a, r, dist_load_rect_attr, selected_attr, dom_class_id );
        a.node.onclick = function(){ openUniformLoadDialog(loadIndex);};

    }
    //our label
    var tokens = label.split(/\n/);
    var lines = tokens.length;

    var bbox = renderedTextSize(label, "12");
    bbox.width += 20;
    bbox.height *= 1.25;

    var labelBoxY = y - length + 6;

    var r2 = myCanvas.rect(x1 + dist/2 - (bbox.width * 0.5), labelBoxY, bbox.width, bbox.height);
    r2.attr(label_rect_attr);
    //let box = myCanvas.rect(x1 + dist/2, dist/2, bbox.width, bbox.height);
    //let box = myCanvas.rect(x1 + dist/2, dist/2, bbox.width, bbox.height);
    //box.attr(label_rect_attr);

    //var l = myCanvas.text(x1 + dist/2, y-length-13*lines, label);
    var l = myCanvas.text(x1 + dist/2, labelBoxY + 10, label);
    l.attr("font-size","12");
    setSelectableTrigger( l, r, dist_load_rect_attr, selected_attr, dom_class_id );
    l.node.onclick = function(){ openUniformLoadDialog(loadIndex);};
    l.toFront();
    return l;
}


function drawCrossSection(shapeData, crossSectionRotation, myCanvas) {
    // draw at upper right

    var plys = 1;
    if(activeProject.isEngineeredLumber) {
        plys = activeProject.numberOfPlys;
    } else if(activeProject.isWood) {
        // parse number off front of name
        var tokens = activeProject.shape["Name"].split("-");
        if(tokens.length === 2) {
            plys = parseInt(tokens[0]);
        }
    }

    var text = shapeName(shapeData);
    if(activeProject.isEngineeredLumber || activeProject.isWood) {
        text += " - " + plys.toString() + " plys";
    }
    var textSize = renderedTextSize(text, 12);
    var frameWidth = textSize.width + 30;
    var frameHeight = 70;

    // draw frame first
    //upper right corner of canvas
    var dom_class_id = "wsSpan_0";
    var r = myCanvas.rect(1, 1, frameWidth, frameHeight, 2);
    r.attr({stroke: "#B8B8B8", fill: "#ffffff"});
    setSelectable(r, {stroke: "#B8B8B8", fill: "#ffffff"}, selected_attr, dom_class_id);
    r.node.onclick = function(){ openModalShapeDialog(); };

    var l = myCanvas.text(frameWidth * 0.5, frameHeight - 15, text);
    l.attr("font-size", "12", "stroke", "#808080");
    setSelectableTrigger(l, r, {stroke: "#B8B8B8", fill: "#ffffff"}, selected_attr, dom_class_id);
    l.node.onclick = function(){ openModalShapeDialog(); };


    var b = 20;
    var d = 30;
    var t = 3;

    // steel shape
    if(isSteelShape(shapeData)) {
        if(isHssRoundShape(shapeData)) {
            var r = d * 0.5;
            var p = drawPipeShape(r, t, myCanvas);
            p.translate(frameWidth * 0.5, 10 + r);
            p.attr({stroke: "#b34332", 'stroke-width': 4});
            setSelectableTrigger(p, r, {stroke: "#b34332", 'stroke-width': 4}, selected_attr, dom_class_id);
            p.node.onclick = function(){ openModalShapeDialog(); };
            return;
        }
        if(isIShape(shapeData)) {
            var p = drawIShape(b, d, t, myCanvas);
        } else if(isTShape(shapeData)) {
            var p = drawTShape(b, d, t, myCanvas);
        } else if(isCShape(shapeData)) {
            var p = drawCShape(b, d, t, myCanvas);
        } else if(isLShape(shapeData)) {
            var p = drawLShape(b, d, t, myCanvas);
        } else if(isHssRectangleShape(shapeData)) {
            var p = drawHSSShape(b, d, t, myCanvas);
        } else if(isHssSquareShape(shapeData)) {
            b = d;
            var p = drawHSSShape(b, d, t, myCanvas);
        } else {
            var p = myCanvas.rect(0, 0, b, d, 1);
        }
        p.translate(frameWidth * 0.5 - b * 0.5, 10);
        p.rotate(crossSectionRotation);
        p.attr({stroke: "#808080", fill: "#b34332"});
        setSelectableTrigger(p, r, {stroke: "#808080", fill: "#b34332"}, selected_attr, dom_class_id);
        p.node.onclick = function(){ openModalShapeDialog(); };
        return;
    }

    if(plys === 1) {
        b = 5;
    }

    var fill  = isWoodShape(shapeData) || isEngineeredLumber(shapeData) ?  "#FCF881" : "#00BFFF";
    var st = myCanvas.set();
    var x = 0;
    var b1 = b / plys;
    for(var i = 0; i < plys; i++) {
        var rect = myCanvas.rect(x, 0, b1, d, 1);
        rect.attr({stroke: "#808080", fill: fill});
        setSelectableTrigger(rect, r, {stroke: "#808080", fill: "#FCF881"}, selected_attr, dom_class_id);
        rect.node.onclick = function(){ openModalShapeDialog(); };
        st.push(rect);
        x += b1;
    }
    st.translate(frameWidth * 0.5 - b * 0.5, 10);
    st.rotate(crossSectionRotation);
    st.attr({stroke: "#808080", fill: fill});
    //setSelectableTrigger(st, r, {stroke: "#808080", fill: "#FCF881"}, selected_attr, dom_class_id);
    //st.node.onclick = function(){ openModalShapeDialog(); };


    // wood shape
    /*var p = myCanvas.rect(0, 0, b * 0.5, d, 1);
    p.translate(frameWidth * 0.5 - b * 0.25, 10);
    p.rotate(crossSectionRotation);
    p.attr({stroke: "#808080", fill: fill});
    setSelectableTrigger(p, r, {stroke: "#808080", fill: "#FCF881"}, selected_attr, dom_class_id);
    p.node.onclick = function(){ openModalShapeDialog(); };*/
}

function renderedTextSize(string, fontSize) {
    var paper = Raphael(0, 0, 0, 0);
    paper.canvas.style.visibility = 'hidden';

    var el = paper.text(0, 0, string);
    el.attr('font-size', fontSize);

    var bBox = el.getBBox();
    paper.remove();

    return {
        width: bBox.width,
        height: bBox.height
    };
}

function pathM( x, y ){return " M " + x + " " + y + " "; }

function pathL( x, y ){return " L " + x + " " + y + " "; }

function drawLine(x1, y1, x2, y2, myCanvas) {
    var pathStr = pathM(x1, y1) + pathL(x2, y2);
    var p = myCanvas.path(pathStr);
    return p;
}

function drawHorizontalDoubleArrow(x1, y1, x2, y2, head_size, myCanvas ) {
    var half_tick = parseInt( head_size*0.5 );
    var pathStr = pathM( x1+half_tick, y1-half_tick );
    pathStr += pathL( x1, y1 );
    pathStr += pathL( x1+half_tick, y1+half_tick);
    pathStr += pathM(x1, y1);
    pathStr += pathL(x2, y2);
    pathStr += pathL(x2 - half_tick, y2-half_tick);
    pathStr += pathM(x2, y2);
    pathStr += pathL(x2 - half_tick, y2+half_tick);
    var p = myCanvas.path(pathStr);
    return p;
}

function drawVerticalDoubleArrow(x1, y1, x2, y2, head_size, myCanvas ) {
    var half_tick = parseInt( head_size*0.5 );
    var pathStr = pathM( x1-half_tick, y1+half_tick );
    pathStr += pathL( x1, y1 );
    pathStr += pathL( x1+half_tick, y1+half_tick);
    pathStr += pathM(x1, y1);
    pathStr += pathL(x2, y2);
    pathStr += pathL(x2 - half_tick, y2-half_tick);
    pathStr += pathM(x2, y2);
    pathStr += pathL(x2 + half_tick, y2-half_tick);
    var p = myCanvas.path(pathStr);
    return p;
}

function drawMomentArrow( x, y, r, myCanvas ) {
    var radius = r;
    var n_section = 15;
    var theta = 1.5*3.14159625/n_section;
    var pathStr = pathM( 0, r );
    var xr = 0;
    var yr = 0;
    for( var i = 0; i < n_section+1; i++ ) {
        xr = r*Number(Math.sin(i*theta));
        yr = r*Number(Math.cos(i*theta));
        //alert( xr + " " + yr );
        pathStr += pathL(xr, yr);
    }
    //yr += head;
    pathStr += pathL(xr - head/2, yr );
    pathStr += pathL(xr, yr + head );
    pathStr += pathL(xr + head/2, yr );
    pathStr += pathL(xr, yr);
    //pathStr += " z";
    var p = myCanvas.path(pathStr);
    p.translate(x, y);
    return p;
}

function drawTriangle( size, x, y, myCanvas ) {
    //M 0 size L size size L size/2 0 L 0 size z
    var pathStr = pathM( 0, size ) + pathL( size, size ) + pathL( size/2, 0 ) + pathL( 0, size ) + " z";
    var p = myCanvas.path(pathStr);
    p.translate(x-size/2, y);
    return p;
}

function drawTrapazoid( x1, y1, x2, y2, q1, q2, myCanvas ) {
    var pathStr = pathM( x1, y1 - q1 ) + pathL( x1, y1 ) + pathL( x2, y2 ) + pathL( x2, y2 - q2 ) + " z";
    var p = myCanvas.path(pathStr);
    return p;
}

function drawDownArrow( x, y, length, myCanvas ) {
    // don't draw arrow head
    var pathStr = pathM( -head/3, -head ) + pathL( 0, 0 ) + pathL( head/3, -head) + pathL( 0, 0 ) + pathL( 0, -length );
    if(length < head * 1.2) {
        pathStr = pathM( 0, 0 ) + pathL( 0, -length );
    }
    var p = myCanvas.path(pathStr);
    p.translate( x, y );
    return p;
}

function drawUpArrow( x, y, length, myCanvas ) {
    var pathStr = pathM( -head/3, -length+head ) + pathL( 0, -length ) + pathL( head/3, -length+head ) + pathL( 0, -length ) + pathL( 0, 0 );
    var p = myCanvas.path(pathStr);
    p.translate( x, y );
    return p;
}

function drawBrace( x, y, size, myCanvas ) {
    var c = myCanvas.circle(x, y, size );
    c.attr( support_attr );
    setSelectable(c, support_attr, selected_attr );
    c.node.onclick = function(){ OpenBracingWidget(); };
    var l = myCanvas.text(x,y,"X");
    l.attr("font-size","12");
    setSelectableTrigger( l, c, support_attr, selected_attr, "" );
    l.node.onclick = function(){ openModalBracingDialog();};
    l.toFront();
    var st = myCanvas.set();
    st.push(c, l );
    return st;
    //return c;
}

//shapes
function drawIShape( b, d, t, canvas ) {
    //upper right corner of canvas
    var pathStr = pathM( 0, 0 );
    pathStr += pathL(0,t);
    pathStr += pathL(b/2-t/2, t);
    pathStr += pathL(b/2-t/2, d-t);
    pathStr += pathL(0, d-t);
    pathStr += pathL(0, d);
    pathStr += pathL(b, d);
    pathStr += pathL(b, d-t);
    pathStr += pathL(b/2+t/2, d-t);
    pathStr += pathL(b/2+t/2, t);
    pathStr += pathL(b, t);
    pathStr += pathL(b, 0 );
    pathStr += " z";
    var p = canvas.path(pathStr);
    return p;
}

function drawTShape( b, d, t, canvas ) {
    //upper right corner of canvas
    var pathStr = pathM( 0, 0 );
    pathStr += pathL(0,t);
    pathStr += pathL(b/2-t/2, t);
    pathStr += pathL(b/2-t/2, d-t);
    pathStr += pathL(b/2+t/2, d-t);
    pathStr += pathL(b/2+t/2, t);
    pathStr += pathL(b, t);
    pathStr += pathL(b, 0 );
    pathStr += " z";
    var p = canvas.path(pathStr);
    return p;
}

function drawCShape( b, d, t, canvas ) {
    //upper right corner of canvas
    var pathStr = pathM( 0, 0 );
    pathStr += pathL(0,d);
    pathStr += pathL(b,d);
    pathStr += pathL(b, d-t);
    pathStr += pathL(t, d-t);
    pathStr += pathL(t, t);
    pathStr += pathL(b, t);
    pathStr += pathL(b, 0 );
    pathStr += " z";
    var p = canvas.path(pathStr);
    return p;
}

function drawLShape( b, d, t, canvas ) {
    //upper right corner of canvas
    var pathStr = pathM( 0, 0 );
    pathStr += pathL(0,d);
    pathStr += pathL(b,d);
    pathStr += pathL(b, d-t);
    pathStr += pathL(t, d-t);
    pathStr += pathL(t, 0);
    pathStr += " z";
    var p = canvas.path(pathStr);
    return p;
}

function drawHSSShape( b, d, t, canvas ) {
    //upper right corner of canvas
    var pathStr = pathM( 0, 0 );
    pathStr += pathL(0,d);
    pathStr += pathL(b,d);
    pathStr += pathL(b,0);
    pathStr += "z";
    pathStr += pathM( t, t );
    pathStr += pathL(b-t,t);
    pathStr += pathL(b-t,d-t);
    pathStr += pathL(t,d-t);
    pathStr += " z";
    var p = canvas.path(pathStr);
    return p;
}

function drawPipeShape(r, t, canvas) {
    return canvas.circle(0, 0, r);
}
